import type { TenantThemeDefinition } from "../../core/types.ts";

const authDesktopLoginBackground = new URL(
  "../../../assets/tenants/bibl/theme/auth/login-bg.png",
  import.meta.url
).href;
const authMobileLoginBackground = new URL(
  "../../../assets/tenants/bibl/theme/auth/mobile-login-bg.png",
  import.meta.url
).href;

export const biblTenantApps = {
  auth: {
    provider: "antd",
    resources: {
      auth: {
        desktopLoginBackground: authDesktopLoginBackground,
        mobileLoginBackground: authMobileLoginBackground,
      },
    },
  },
  admin: {
    provider: "antd",
  },
  user: {
    provider: "antd",
  },
  h5: {
    provider: "antd-mobile",
  },
  "customer-h5": {
    provider: "antd",
  },
} satisfies TenantThemeDefinition["apps"];
